import { render } from "./FootballEvent.vue?vue&type=template&id=b238877c&scoped=true"
import script from "./FootballEvent.vue?vue&type=script&lang=js"
export * from "./FootballEvent.vue?vue&type=script&lang=js"

import "./FootballEvent.vue?vue&type=style&index=0&id=b238877c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b238877c"]])

export default __exports__